module.exports = __webpack_public_path__ + "static/media/down-icon.26aa8f37.svg";